import DataQuery from 'data/DataQuery';
import { Customer_PaymentMethods } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import IAppState from 'infrastructure/store/IAppState';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import React from 'react';
import { useSelector } from 'react-redux';
import ContractFullDTO from '../dtos/ContractFullDTO';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import FuelingContractBasicInfoCard from '../components/fueling/FuelingContractBasicInfoCard';
import SendingMethodsCard from '../components/SendingMethodsCard';
import FuelingCardsSection from './FuelingCardsSection';
import PaymentMethodDTO from 'features/payments/dtos/PaymentMethodDTO';
import PaymentMethodList from 'features/payments/components/PaymentMethodList';

const numberOfShowContacts = 3;

type Props = {
  contract: ContractFullDTO;
}

const FuelingContractDetailSection = ({ contract }: Props) => {
  // store
  const customer = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  // payment methods
  const paymentMethodsQuery: DataQuery = {
    url: Customer_PaymentMethods,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: new URLSearchParams([["ContractId", contract.contractId!], ["IsFuelingContract", String(true)]])
  };
  const { data: paymentMethods, loadStatus: paymentMethodsLoadStatus } = useQuery<PaymentMethodDTO[]>(paymentMethodsQuery, [], [contract.contractId, customer]);

  // render
  return (
    <>
      <FuelingContractBasicInfoCard 
        contract={contract}
      />
      <SendingMethodsCard
        mailMethods={contract.mailMethod || []}
        contacts={contract.contact || []}
        address={contract.address!}
        contactsCount={numberOfShowContacts}
      />
      <NoContentWrapper
        data={paymentMethods}
        loadStatus={[
          paymentMethodsLoadStatus
        ]}
        noContentRender={() => <></>}
      >
        <PaymentMethodList 
          paymentMethods={paymentMethods} 
          enabledAdvanceInvoicing={false}
        />
      </NoContentWrapper>
      <FuelingCardsSection 
        fuelingContractId={contract.contractId!}
      />
    </>
  );
}

export default FuelingContractDetailSection;